if (!customElements.get('landscape-card-product')) {
  class LandscapeCardProduct extends HTMLElement {
    constructor() {
      super();

      this.quickviewModalsHTML = {};
      this.variants = JSON.parse(
        this.querySelector('[type="application/json"][data-variants]')
          .textContent
      );
      this.activeVariant = this.variants?.find(
        variant => variant.id === Number(this.dataset.activeVariantId)
      );
    }
  }

  customElements.define(
    'landscape-card-product',
    LandscapeCardProduct
  );
}
